import * as React from 'react';
import { KitchenContext, KitchenThemeContext } from '../../../../App';
export interface Props {}

const UpdatesPreview: React.FC<Props> = (_props) => {
  const { theme: _theme } = React.useContext(KitchenThemeContext);
  const { updates: _updates, isLoadingUpdates: _isLoadingUpdates } = React.useContext(KitchenContext);

  return null;

  // const { version, versionUpdates, versionDate } = updates[0] || {};
  // const navigate = useNavigate();
  // let updateCopy: any[] = [];
  // for (let key in versionUpdates) {
  //   if (versionUpdates[key]) {
  //     updateCopy.push({
  //       key: capitalizeFirstLetter(key),
  //       arr: versionUpdates[key],
  //     });
  //   }
  // }

  // let displayUpdates = updateCopy.map((item, i) => {
  //   const subArray = item.arr
  //     ? item.arr.map((subItem: any, j: number) => {
  //         return (
  //           <div style={{ display: 'flex', alignItems: 'space-between' }}>
  //             <XIIcon icon="check" iconSize={24} />
  //             <div style={{ flex: 1 }}>{NewUpdate(subItem)}</div>
  //           </div>
  //         );
  //       })
  //     : null;

  //   return (
  //     <React.Fragment key={`displayUpdates_${i}`}>
  //       <p className="kxi-text-600 kxi-text-normal">{item.key}</p>
  //       {subArray}
  //     </React.Fragment>
  //   );
  // });
  // return (
  //   <UpdatesPreviewWrapper>
  //     <AlertInlineMain
  //       title="Just getting started?"
  //       subtitle="See our FAQ for installation instructions."
  //       color={theme}
  //       buttons={{
  //         primary: {
  //           text: "Let's Go",
  //           onClick: () => {
  //             navigate('/FAQ');
  //           },
  //         },
  //       }}
  //     />

  //     {isLoadingUpdates ? (
  //       FetchingUpdates()
  //     ) : (
  //       <>
  //         <TopText>
  //           <LeftSideText>
  //             <p className="kxi-text-medium kxi-text-400">Latest Update</p>
  //             <p className="kxi-text-small kxi-text-400">
  //               {version} on {versionDate}
  //             </p>
  //           </LeftSideText>
  //           <Link to="/Updates">
  //             <DefaultButton fill="outline" buttonSize="normal" text="See More" color={theme} />
  //           </Link>
  //         </TopText>
  //         <BottomText>{displayUpdates}</BottomText>
  //       </>
  //     )}
  //   </UpdatesPreviewWrapper>
  // );
};
export default UpdatesPreview;
